import * as myATC from '../../js/myATC';

var ATClient_ws;
var pmAgent_Uid = "";
var pmAgent_Result = "";
function ATConnect(d) {
    var c = "FAIL";
    // var b = /^(\d+)\.(\d+)\.(\d+)\.(\d+):(\d+)$/g;
    // if (b.test(d)) {
        if (ATClient_ws != null) {
            ATClient_ws = null
        }
        if (ATClient_ws == null) {
            var a = "wss://" + d;
            ATClient_ws = new WebSocket(a);
            ATClient_ws.binaryType = "arraybuffer";
            ATClient_ws.onmessage = function (e) {
                onReceiveData_Changed(e.data, 0)
            };
            ATClient_ws.onclose = function (e) {
                myATC.onReceivePopupInfo(100, "ATClient_ws \ufffd\ufffd\ufffd\ufffd\ufffd\u0479\u0631\u0561\ufffd", e.code + "-" + e.reason);
                ATClient_ws = null
            };
            ATClient_ws.onerror = function (e) {
                myATC.onReceivePopupInfo(100, "ATClient_ws \ufffd\ufffd\ufffd\u04f3\ufffd\ufffd\ufffd", e.reason);
                ATClient_ws = null
            };
            ATClient_ws.onopen = function (e) {
                pmAgent_Result = "OK"
            };
            c = "OK"
        }
    // }
    return c
}
function ATDisconnect() {
    var a = "OK";
    if (ATClient_ws != null) {
        ATClient_ws.close()
    }
    ATClient_ws = null;
    return a
}
function ATLogin_ex(h, b, a, g, c) {
    var e = "FAIL";
    if (ATClient_available() == true) {
        var f = myEncode_build_login(h, b, a, g, c);
        ATClient_send(f);
        e = "OK";
        var d = new Date();
        m_dtLast_timer_send = d.getTime();
        m_dtLast_timer = d.getTime();
        setTimeout(() => {
            check_echo_5s_timer();
        }, 5000);
        pmAgent_Uid = h
    }
    return e
}
function ATLogout_ex(c) {
    var a = "FAIL";
    if (ATClient_available() == true) {
        var b = myEncode_build_logout(c);
        ATClient_send(b);
        a = "OK";
        myATC.onReceivePopupInfo(1, pmAgent_Uid, "00")
    }
    return a
}
function ATReady() {
    var a = "FAIL";
    if (window.WebSocket) {
        a = "OK"
    } else {
        a = "WebSocket not supported by this browser!"
    }
    return a
}
function ATCommandResult() {
    var a = pmAgent_Result;
    if (a.length > 0) {
        pmAgent_Result = ""
    }
    return a
}
function ATTimerEcho(a, d) {
    var b = "FAIL";
    if (ATClient_available() == true) {
        var c = myEncode_build_TimerEcho(a, d);
        ATClient_send(c);
        b = "OK"
    }
    return b
}
var bWait_conn_echo = false;
var m_dtLast_timer = 0;
var m_dtLast_timer_send = 0;
function check_echo_5s_timer() {
    if (ATClient_available() == true) {
        var a;
        var b = new Date();
        if (bWait_conn_echo == false) {
            a = b.getTime() - m_dtLast_timer_send;
            if (a > 25000) {
                ATTimerEcho("CONN_DATA", pmAgent_Uid);
                bWait_conn_echo = true;
                m_dtLast_timer = b.getTime();
                m_dtLast_timer_send = b.getTime()
            }
        } else {
            a = b.getTime() - m_dtLast_timer;
            if (a > 10000) {
                ATDisconnect();
                bWait_conn_echo = false;
                myATC.onReceivePopupInfo(100, "ATClient_ws \ufffd\ufffd\ufffd\u04f3\ufffd\ufffd\ufffd", "Wait CONN_ECHO timeout")
            }
        }
        setTimeout(() => {
            check_echo_5s_timer();
        }, 5000)
    }
}
function ATClient_available() {
    var a = false;
    if ((ATClient_ws != null) && (ATClient_ws.readyState == 1)) {
        a = true
    }
    return a
}
function ATClient_send(d) {
    var b = false;
    try {
        if (ATClient_available() == true) {
            ATClient_ws.send(d);
            var c = new Date();
            m_dtLast_timer_send = c.getTime();
            b = true
        }
    } catch (a) {
        ATClient_ws.close();
        myATC.onReceivePopupInfo(100, "ATClient_ws \ufffd\ufffd\ufffd\u04f3\ufffd\ufffd\ufffd", "\ufffd\ufffd\ufffd\ufffd\u02a7\ufffd\ufffd")
    }
    return b
}
function onReceiveData_Changed(c, a) {
    try {
        onReceiveData_Changed_safe(c, a)
    } catch (b) {
        alert(b.message)
    }
}

//0,1,byteLength-1:标识符
//2,3:信息长度
//4,5,6:空缺
//7~byteLength(2,3):信息内容
function onReceiveData_Changed_safe(l, f) {
    var g = "";
    var e;
    var h = l.byteLength;//总的字节长度
    var m = new Uint8Array(l, 0);//转化成Uint8类型
    if ((m[0] == 2) && (m[1] == 16) && (m[h - 1] == 3)) {//以2，6开头，以3结尾
        var j = 2;
        var o = (m[j++] << 8) | (m[j++]);//拼接2，3字节；2，3字节代表信息的长度
        m = new Uint8Array(l, j + 3, o);//获取从7字节开始，2，3字节所示长度的内容
        var i = get_ie_str(1, m, o);
        if ((i == "LOGIN") || (i == "LOGOUT")) {
            var r = get_ie_str(3, m, o);
            e = get_ie_str(4, m, o);
            if ((i == "LOGIN")) {
                if (r == "1") {
                    pmAgent_Result = "OK";
                    myATC.onReceivePopupInfo(1, pmAgent_Uid, "01")
                } else {
                    if (e.length > 0) {
                        pmAgent_Result = e
                    }
                }
            } else {
                if ((i == "LOGOUT")) {
                    if (r == "1") {
                        pmAgent_Result = "OK";
                        myATC.onReceivePopupInfo(1, pmAgent_Uid, "00")
                    }
                }
            }
        } else {
            if (i == "POPUP") {
                g = get_ie_str(200, m, o);
                var q = get_ie_int(27, m, o);
                var p = get_ie_str(28, m, o);
                var n = get_ie_str(59, m, o);
                if ((q == 1) && (g == pmAgent_Uid)) {
                    myATC.onReceivePopupInfo(1, g, n);
                    return
                } else {
                    if ((q == 2) && (p == "SETUP")) {
                        var b = n.split("|");
                        if (b.length == 5) {
                            var a = b[0];
                            var c = b[1];
                            var k = b[2];
                            g = b[3];
                            var d = b[4];
                            if (d == "1") {
                                myATC.onReceivePopupInfo(6, c, a);
                                return
                            }
                            if (c.length > 0) {
                                myATC.onReceivePopupInfo(4, c, a);
                                if (g.length > 0) {
                                    myATC.onReceivePopupInfo(2, g, a)
                                }
                            }
                            if (k.length > 0) {
                                myATC.onReceivePopupInfo(3, k, a)
                            }
                        }
                        return
                    }
                }
                myATC.onReceivePopupInfo(q, p, n)
            } else {
                if (i == "CONN_DATA") {
                    var s = "CONN_ECHO";
                    ATTimerEcho(s, pmAgent_Uid)
                } else {
                    if (i == "CONN_ECHO") {
                        bWait_conn_echo = false
                    }
                }
            }
        }
    }
}
function get_ie_str(i, c, k) {
    var h = "";
    var e;
    var b = 0;
    var f;
    for (var a = 0; a < k; ) {
        e = c[a++];//第0字节：内容标识符
        f = c[a++];//第1字节
        b = f << 8 | c[a++];//拼接第1第2字节：该标识符的信息长度
        if (b > (k - a)) {//信息长度超过数组大小（越界，溢出），属于非法数据
            break
        }
        if (e == i) {//判定是否是要获取的内容
            var g = new ArrayBuffer(b);//初始化新的存储空间，与标识符的信息长度一致
            var l = new Uint8Array(g, 0);//转换成字节数组
            for (var d = 0; d < b; d++) {//循环获取字节内容
                l[d] = c[a + d]
            }
            h = DecodeGb2312_fromByte(l, b);//字节解码
            break
        }
        a = a + b//指向下一标识符
    }
    return h
}
function DecodeGb2312_fromByte(g, f) {
    var e = "";
    var d,
    c,
    a;
    for (var b = 0; b < f; b++) {
        d = g[b];
        if (d < 127) {
            e += String.fromCharCode(d)
        } else {
            if (g[b + 1] > 127) {
                c = (g[b] << 8) + g[b + 1];
                a = gb2312_to_unicode(c);
                e += String.fromCharCode(a);
                b++
            } else {
                e += String.fromCharCode(d)
            }
        }
    }
    return e
}
function get_ie_int(i, c, k) {
    var g = -1;
    var f;
    var b = 0;
    var h;
    for (var a = 0; a < k; ) {
        f = c[a++];
        h = c[a++];
        b = h << 8 | c[a++];
        if (b > (k - a)) {
            break
        }
        if (f == i) {
            var e = "";
            for (var d = 0; d < b; d++) {
                e += String.fromCharCode(c[a + d])
            }
            g = parseInt(e);
            break
        }
        a = a + b
    }
    return g
}
function myEncode_build_login(a, b, j, m, e) {
    if (e.indexOf("PROTOCOL=1;") < 0) {
        e = "PROTOCOL=1;VER=120;" + e
    }
    var n = 0;
    var d = new ArrayBuffer(1024);
    var p = new Uint8Array(d, 0);
    var g = 0;
    var o = 0;
    p[o++] = 2;
    p[o++] = 16;
    p[o++] = 16;
    p[o++] = 16;
    p[o++] = 32;
    p[o++] = 80;
    p[o++] = 32;
    var k = "LOGIN";
    n = strLen(k);
    p[o++] = 1;
    p[o++] = (n >> 8);
    p[o++] = (n & 255);
    for (g = 0; g < n; g++) {
        p[o++] = k.charCodeAt(g)
    }
    k = a;
    n = strLen(k);
    p[o++] = 200;
    p[o++] = (n >> 8);
    p[o++] = (n & 255);
    for (g = 0; g < n; g++) {
        p[o++] = k.charCodeAt(g)
    }
    k = b;
    n = strLen(k);
    p[o++] = 205;
    p[o++] = (n >> 8);
    p[o++] = (n & 255);
    for (g = 0; g < n; g++) {
        p[o++] = k.charCodeAt(g)
    }
    k = j;
    n = strLen(k);
    p[o++] = 21;
    p[o++] = (n >> 8);
    p[o++] = (n & 255);
    for (g = 0; g < n; g++) {
        p[o++] = k.charCodeAt(g)
    }
    k = m;
    n = strLen(k);
    p[o++] = 202;
    p[o++] = (n >> 8);
    p[o++] = (n & 255);
    for (g = 0; g < n; g++) {
        p[o++] = k.charCodeAt(g)
    }
    k = e;
    n = strLen(k);
    p[o++] = 28;
    p[o++] = (n >> 8);
    p[o++] = (n & 255);
    for (g = 0; g < n; g++) {
        p[o++] = k.charCodeAt(g)
    }
    p[o++] = 0;
    p[o++] = 0;
    p[o++] = 3;
    n = o;
    var c = n - 6;
    p[2] = (c >> 8);
    p[3] = (c & 255);
    var f;
    try {
        f = d.slice(0, n)
    } catch (h) {
        f = new ArrayBuffer(n);
        var l = new Uint8Array(f);
        for (g = 0; g < n; g++) {
            l[g] = p[g]
        }
    }
    return f
}
function myEncode_build_logout(a) {
    var j = 5;
    var b = new ArrayBuffer(1024);
    var k = new Uint8Array(b, 0);
    var e = 0;
    var l = 0;
    k[l++] = 2;
    k[l++] = 16;
    k[l++] = 16;
    k[l++] = 16;
    k[l++] = 32;
    k[l++] = 80;
    k[l++] = 32;
    var g = "LOGOUT";
    j = strLen(g);
    k[l++] = 1;
    k[l++] = (j >> 8);
    k[l++] = (j & 255);
    for (e = 0; e < j; e++) {
        k[l++] = g.charCodeAt(e)
    }
    g = a;
    j = strLen(g);
    k[l++] = 200;
    k[l++] = (j >> 8);
    k[l++] = (j & 255);
    for (e = 0; e < j; e++) {
        k[l++] = g.charCodeAt(e)
    }
    k[l++] = 0;
    k[l++] = 0;
    k[l++] = 3;
    j = l;
    var c = j - 6;
    k[2] = (c >> 8);
    k[3] = (c & 255);
    var d;
    try {
        d = b.slice(0, j)
    } catch (f) {
        d = new ArrayBuffer(j);
        var h = new Uint8Array(d);
        for (e = 0; e < j; e++) {
            h[e] = k[e]
        }
    }
    return d
}
function myEncode_build_TimerEcho(h, a) {
    var k = 5;
    var c = new ArrayBuffer(1024);
    var l = new Uint8Array(c, 0);
    var e = 0;
    var m = 0;
    l[m++] = 2;
    l[m++] = 16;
    l[m++] = 16;
    l[m++] = 16;
    l[m++] = 32;
    l[m++] = 80;
    l[m++] = 32;
    var g = h;
    k = strLen(g);
    l[m++] = 1;
    l[m++] = (k >> 8);
    l[m++] = (k & 255);
    for (e = 0; e < k; e++) {
        l[m++] = g.charCodeAt(e)
    }
    g = a;
    k = strLen(g);
    l[m++] = 200;
    l[m++] = (k >> 8);
    l[m++] = (k & 255);
    for (e = 0; e < k; e++) {
        l[m++] = g.charCodeAt(e)
    }
    l[m++] = 0;
    l[m++] = 0;
    l[m++] = 3;
    k = m;
    var b = k - 6;
    l[2] = (b >> 8);
    l[3] = (b & 255);
    var d;
    try {
        d = c.slice(0, k)
    } catch (f) {
        d = new ArrayBuffer(k);
        var j = new Uint8Array(d);
        for (e = 0; e < k; e++) {
            j[e] = l[e]
        }
    }
    return d
}
function strLen(a) {
    a = a.replace(/[^\x00-\xff]/g, "**");
    return a.length
}

module.exports = {
    ATConnect,
    ATDisconnect,
    ATLogin_ex,
    ATLogout_ex,
    ATReady,
    ATCommandResult,
    ATTimerEcho,
    check_echo_5s_timer,
    ATClient_available,
    ATClient_send,
    get_ie_int,
    onReceiveData_Changed,
    onReceiveData_Changed_safe,
    get_ie_str,
    DecodeGb2312_fromByte,
    myEncode_build_login,
    myEncode_build_logout,
    myEncode_build_TimerEcho,
    strLen,
}
